import React from 'react';
import { Box, Flex, useColorModeValue } from '@chakra-ui/react';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import { Outlet } from 'react-router-dom';

const DashboardLayout = () => {
  const bgColor = useColorModeValue('gray.50', 'gray.900');

  return (
    <Box minH="100vh" bg={bgColor}>
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content */}
      <Box
        ml={{ base: 0, md: "64" }}
        transition="margin-left 0.2s"
        minH="100vh"
        position="relative"
      >
        <Navbar />
        <Box p="4">
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardLayout; 